import { connect } from 'react-redux';

import { IAppState } from '../../../common/state';

import { CoworkingOfferType as Component } from './CoworkingOfferType';

export const mapState = (state: IAppState) => ({
  isCoworkingWorkplaceAvailable: state.isCoworkingWorkplaceAvailable,
});

export const CoworkingOfferType = connect(mapState)(Component);
